"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importStar(require("react"));

const react_spring_1 = require("react-spring");

const DialogContainer_1 = __importDefault(require("../dialog-container/DialogContainer"));

const styled_components_1 = __importDefault(require("styled-components"));

const AnimatedDialogContainer = _a => {
  var {
    visible,
    children,
    transition = defaultTransition
  } = _a,
      props = __rest(_a, ["visible", "children", "transition"]);

  const dialogRef = react_1.useRef();
  const transitions = react_spring_1.useTransition(visible, null, typeof transition === 'function' ? transition(dialogRef.current) : transition);
  return react_1.default.createElement(react_1.Fragment, null, transitions.map(transition => transition.item && react_1.default.createElement(StyledDialogContainer, Object.assign({
    visible: true,
    key: transition.key,
    style: {
      background: transition.props.background,
      pointerEvents: transition.props.pointerEvents
    }
  }, props), react_1.default.createElement(react_spring_1.animated.div, {
    ref: dialogRef,
    style: {
      opacity: transition.props.opacity,
      transform: transition.props.transform
    }
  }, children))));
};

exports.default = AnimatedDialogContainer;
const defaultTransition = {
  from: {
    opacity: 0,
    background: 'rgba(0, 0, 0, 0)',
    pointerEvents: 'none'
  },
  enter: {
    opacity: 1,
    background: 'rgba(0, 0, 0, 0.1)',
    pointerEvents: 'initial'
  },
  leave: {
    opacity: 0,
    background: 'rgba(0, 0, 0, 0)',
    pointerEvents: 'none'
  },
  config: {
    mass: 2,
    tension: 400,
    friction: 50
  }
};
const StyledDialogContainer = react_spring_1.animated(styled_components_1.default(DialogContainer_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: transparent;\n  pointer-events: none;\n"]))));